export const activitiesConstants = {
    ACTIVITIES_REQUEST: "ACTIVITIES_REQUEST",
    ACTIVITIES_SUCCESS: "ACTIVITIES_SUCCESS",
    ACTIVITIES_FAILURE: "ACTIVITIES_FAILURE",

    ARCHIVE_REQUEST: "ARCHIVE_ACTIVITY_REQUEST",
    ARCHIVE_SUCCESS: "ARCHIVE_ACTIVITY_SUCCESS",
    ARCHIVE_FAILURE: "ARCHIVE_ACTIVITY_FAILURE",

    UPLOAD_SUCCESS: "UPLOAD_ACTIVITY_SUCESS",
    UPLOAD_FAILURE: "UPLOAD_ACTIVITY_FAILURE",

    UPDATE_FILTERS: "UPDATE_ACTIVITIES_FILTERS",
    SET_PAGE: "SET_ACTIVITIES_PAGE",
    
    ACTIVITIES_RESET_STATE: "ACTIVITIES_RESET_STATE",

    ACTIVITY_STATUS: "UPDATE_ACTIVITY_STATUS",
    TIMER_STATUS: "UPDATE_TIMER_STATUS",
    CALIBRATION_SATUS: "UPDATE_CALIBRATION_STATUS",
    CURRENT_REP: "UPDATE_CURRENT_REP_STATUS",
    
    // Timer actions
    UPDATE_ELAPSED_TIME: "UPDATE_ELAPSED_TIME",
    RESET_ELAPSED_TIME: "RESET_ELAPSED_TIME",
    
    // Chart data actions
    UPDATE_CHART_DATA: "UPDATE_CHART_DATA",
    ADD_CHART_DATA_POINT: "ADD_CHART_DATA_POINT",
    ADD_CHART_DATA_POINTS: "ADD_CHART_DATA_POINTS",
    CLEAR_CHART_DATA: "CLEAR_CHART_DATA",
    UPDATE_CHART_MAX_VALUES: "UPDATE_CHART_MAX_VALUES",
    
    // Sensor data actions
    ADD_SENSOR_DATA_POINT: "ADD_SENSOR_DATA_POINT",
    CLEAR_SENSOR_DATA: "CLEAR_SENSOR_DATA",
    
    // Workout state management
    INITIALIZE_WORKOUT: "INITIALIZE_WORKOUT",
    START_WORKOUT: "START_WORKOUT",
    PAUSE_WORKOUT: "PAUSE_WORKOUT",
    RESUME_WORKOUT: "RESUME_WORKOUT",
    COMPLETE_REP: "COMPLETE_REP",
    COMPLETE_WORKOUT: "COMPLETE_WORKOUT",
    RESET_WORKOUT: "RESET_WORKOUT",
    
    // Rep timer management
    START_REP_TIMER: "START_REP_TIMER",
    STOP_REP_TIMER: "STOP_REP_TIMER",
    RESET_REP_TIMER: "RESET_REP_TIMER",
    UPDATE_REP_ELAPSED_TIME: "UPDATE_REP_ELAPSED_TIME",
    
    // Global timer management
    START_GLOBAL_TIMER: "START_GLOBAL_TIMER",
    STOP_GLOBAL_TIMER: "STOP_GLOBAL_TIMER",
    RESET_GLOBAL_TIMER: "RESET_GLOBAL_TIMER",
    UPDATE_GLOBAL_ELAPSED_TIME: "UPDATE_GLOBAL_ELAPSED_TIME",
    
    // Current strength display
    UPDATE_CURRENT_STRENGTH: "UPDATE_CURRENT_STRENGTH",
    
    // Workout-wide chart data
    ADD_WORKOUT_CHART_DATA_POINT: "ADD_WORKOUT_CHART_DATA_POINT",
    CLEAR_WORKOUT_CHART_DATA: "CLEAR_WORKOUT_CHART_DATA",
};